import { Component, ChangeEvent } from 'react';
import styled from 'styled-components';
import { getTextStyle } from '../../content/texts/bou-text/text-style';
import { BouColor } from '../../global/bou-colors';
import { defaultMobileBreakpointDEPRECATED, themeDEPRECATED } from '../../global/styles';

interface InputProps {
  isEmpty: boolean;
  isError: boolean;
}

const Input = styled.input`
  ${getTextStyle({ size: 'xxs' })};
  width: 100%;
  display: block;
  padding: 18px 4px 16px 24px;
  border: 0;
  border: 1px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
  border-bottom: 4px solid
    ${({ isEmpty, isError }: InputProps) =>
      isError
        ? themeDEPRECATED.colors.redError()
        : isEmpty
          ? `1px solid ${BouColor.TOOL_BORDER_DARK_GRAY}`
          : themeDEPRECATED.colors.green()};

  &:focus,
  &:active {
    outline: none;
  }

  &:disabled {
    background-color: ${BouColor.TOOL_DISABLED_GRAY};
  }
  resize: vertical;
`;

const HeaderRow = styled.div`
  margin-bottom: 6px;
  line-height: 1.88;
`;

const Label = styled.label`
  ${themeDEPRECATED.fontMedium};
  display: inline-block;
  letter-spacing: -0.2px;
`;

const MetaLabel = styled(Label)`
  margin-left: 18px;
  color: ${themeDEPRECATED.colors.grayWarm()};
  @media (max-width: ${defaultMobileBreakpointDEPRECATED}px) {
    margin-left: 0;
    margin-top: -3px;
    display: block;
  }
`;

const ErrorMessage = styled(Label)`
  margin-left: 18px;
  color: ${themeDEPRECATED.colors.redError()};
`;

const Root = styled.div`
  width: 100%;
`;

interface PassedProps {
  label: string | JSX.Element | JSX.Element[];
  value?: string | number;
  metaLabel?: string;
  errorMessage?: string;
  isError?: boolean;
  disabled?: boolean;
  placeholder?: string;
  type: 'text' | 'password' | 'textarea' | 'number';
  className?: string;
  id?: string;
  onChange: (newValue: string) => void;
}

type Props = PassedProps;

interface State {
  hideErrorMesage: boolean;
}

export class TextField extends Component<Props> {
  public state: State = {
    hideErrorMesage: true,
  };

  private renderLabel() {
    const { label, id } = this.props;
    if (typeof label === 'string') {
      return <Label htmlFor={id}>{label}</Label>;
    }
    return label;
  }

  public render() {
    const { value, errorMessage, onChange, type, disabled, id, metaLabel, placeholder, isError, className } =
      this.props;
    const hideErrorMesage = !value || this.state.hideErrorMesage;

    return (
      <Root className={className}>
        <HeaderRow>
          {this.renderLabel()}
          {metaLabel && <MetaLabel>{metaLabel}</MetaLabel>}
          {!hideErrorMesage && isError && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </HeaderRow>
        {type === 'textarea' ? (
          <Input
            as={'textarea'}
            isError={!!isError}
            isEmpty={!value}
            id={id}
            placeholder={placeholder}
            value={value || ''}
            disabled={disabled}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onChange(e.currentTarget.value)}
            onBlur={() => {
              this.setState({ hideErrorMesage: false });
            }}
            onFocus={() => {
              this.setState({ hideErrorMesage: true });
            }}
          />
        ) : (
          <Input
            isError={!!isError}
            isEmpty={!value}
            id={id}
            placeholder={placeholder}
            value={value || ''}
            type={type}
            disabled={disabled}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.currentTarget.value)}
            onBlur={() => {
              this.setState({ hideErrorMesage: false });
            }}
            onFocus={() => {
              this.setState({ hideErrorMesage: true });
            }}
          />
        )}
      </Root>
    );
  }
}
